import { DIAL_DURATION_MS, SECTION_REVEAL_MS } from 'src/lib/constants.ts';

/** Standard easing curve (cubic-bezier) shared across transitions. */
export const EASE_STANDARD: [number, number, number, number] = [0.4, 0, 0.2, 1];

/** Page enter/animate/exit transition (PageMotion). */
export const PAGE_TRANSITION = { duration: 0.25, ease: EASE_STANDARD };

/** Per-question fade/slide transition (CheckPage). */
export const QUESTION_TRANSITION = { duration: 0.2 };

/** ScoreDial ring sweep transition (seconds; mirrors DIAL_DURATION_MS). */
export const DIAL_TRANSITION = {
  duration: DIAL_DURATION_MS / 1000,
  ease: EASE_STANDARD
};

/**
 * Scroll-reveal entrance. Spread onto a `motion` element to fade + lift it
 * into view once. Honors `prefers-reduced-motion` via the app-level
 * `MotionConfig reducedMotion="user"` (transforms are dropped, content stays).
 */
export const SECTION_REVEAL = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: SECTION_REVEAL_MS / 1000, ease: EASE_STANDARD }
};

/**
 * Staggered list reveal. Put `STAGGER_CONTAINER` on the wrapper and
 * `STAGGER_CHILD` on each child `motion` element.
 */
export const STAGGER_CONTAINER = {
  initial: 'hidden',
  whileInView: 'show',
  viewport: { once: true, margin: '-80px' },
  variants: {
    hidden: {},
    show: { transition: { staggerChildren: 0.06 } }
  }
};

export const STAGGER_CHILD = {
  variants: {
    hidden: { opacity: 0, y: 12 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: EASE_STANDARD }
    }
  }
};

/** Spring for tactile hover/tap lift on interactive elements (CTAs, cards). */
export const HOVER_SPRING = { type: 'spring', stiffness: 400, damping: 30 } as const;
